export default __webpack_public_path__ + "static/media/icon-USDC.f5128e2a.svg";